export interface ExampleProject {
  id: string;
  name: string;
  description: string;
  boardId: string;
  workspaceState: object;
}

export const examples: ExampleProject[] = [
  {
    id: 'blink',
    name: 'Blink',
    description: 'Blink the built-in LED on and off every second.',
    boardId: 'arduino-uno',
    workspaceState: {
      blocks: {
        languageVersion: 0,
        blocks: [
          {
            type: 'arduino_program',
            id: 'program1',
            x: 40,
            y: 40,
            inputs: {
              SETUP: {
                block: {
                  type: 'arduino_pin_mode',
                  id: 'pinmode1',
                  fields: { PIN: '13', MODE: 'OUTPUT' },
                },
              },
              LOOP: {
                block: {
                  type: 'arduino_digital_write',
                  id: 'dw1',
                  fields: { PIN: '13', STATE: 'HIGH' },
                  next: {
                    block: {
                      type: 'arduino_delay',
                      id: 'd1',
                      inputs: {
                        MS: { block: { type: 'math_number', id: 'n1', fields: { NUM: 1000 } } },
                      },
                      next: {
                        block: {
                          type: 'arduino_digital_write',
                          id: 'dw2',
                          fields: { PIN: '13', STATE: 'LOW' },
                          next: {
                            block: {
                              type: 'arduino_delay',
                              id: 'd2',
                              inputs: {
                                MS: {
                                  block: { type: 'math_number', id: 'n2', fields: { NUM: 1000 } },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        ],
      },
    },
  },
  {
    id: 'serial-hello',
    name: 'Serial Hello',
    description: 'Print Hello World to the serial monitor.',
    boardId: 'arduino-uno',
    workspaceState: {
      blocks: {
        languageVersion: 0,
        blocks: [
          {
            type: 'arduino_program',
            id: 'program1',
            x: 40,
            y: 40,
            inputs: {
              SETUP: {
                block: {
                  type: 'arduino_serial_begin',
                  id: 'serial1',
                  fields: { BAUD: '9600' },
                },
              },
              LOOP: {
                block: {
                  type: 'arduino_serial_println',
                  id: 'print1',
                  inputs: {
                    TEXT: {
                      block: { type: 'text', id: 't1', fields: { TEXT: 'Hello from Skyrover IDE!' } },
                    },
                  },
                  next: {
                    block: {
                      type: 'arduino_delay',
                      id: 'd1',
                      inputs: {
                        MS: { block: { type: 'math_number', id: 'n1', fields: { NUM: 1000 } } },
                      },
                    },
                  },
                },
              },
            },
          },
        ],
      },
    },
  },
  {
    id: 'analog-read',
    name: 'Analog Read',
    description: 'Read an analog sensor and print the value over serial.',
    boardId: 'arduino-uno',
    workspaceState: {
      blocks: {
        languageVersion: 0,
        blocks: [
          {
            type: 'arduino_program',
            id: 'program1',
            x: 40,
            y: 40,
            inputs: {
              SETUP: {
                block: {
                  type: 'arduino_serial_begin',
                  id: 'serial1',
                  fields: { BAUD: '9600' },
                },
              },
              LOOP: {
                block: {
                  type: 'arduino_serial_println',
                  id: 'print1',
                  inputs: {
                    TEXT: {
                      block: {
                        type: 'arduino_analog_read',
                        id: 'aread1',
                        fields: { PIN: 'A0' },
                      },
                    },
                  },
                  next: {
                    block: {
                      type: 'arduino_delay',
                      id: 'd1',
                      inputs: {
                        MS: { block: { type: 'math_number', id: 'n1', fields: { NUM: 500 } } },
                      },
                    },
                  },
                },
              },
            },
          },
        ],
      },
    },
  },
];

export function getExampleById(id: string): ExampleProject | undefined {
  return examples.find((e) => e.id === id);
}
